import * as types from '@/store/types'
export default {
    loadAlbumItems(context, payload) {
        context.albumVkItems = payload
        context.albumVkItemsLoaded = true
        context.albumVkItemsLoaded = false
    }
}
